import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { DropdownModule } from 'primeng/dropdown';
import { TableModule } from 'primeng/table';
import { TagModule } from 'primeng/tag';
import { AdminService } from '../../services/admin.service';
import { DirectionService } from '../../services/direction.service';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-admin-report',
  standalone: true,
  imports: [DropdownModule, TranslateModule, TagModule, FormsModule, CommonModule, TableModule, ButtonModule],
  templateUrl: './admin-report.component.html',
  styleUrl: './admin-report.component.scss'
})
export class AdminReportComponent implements OnInit {

  users = [] as any[]
  selectedType = "";
  reportHeader = "";
  dir!: 'rtl' | 'ltr';


  constructor(private adminService: AdminService, private directionService: DirectionService) {


  }
  ngOnInit(): void {
    this.selectedType = 'all';
    this.adminService.viewUsersReport('all').subscribe((response: any) => {
      const { reportHeader, users } = response['data'];
      this.users = users;
      this.reportHeader = reportHeader;
    })
    this.directionService.direction$.subscribe((dir) => {
      this.dir = dir;
      if (this.dir == 'rtl') {
        this.reports = [
          {
            id: "department_admin",
            name: "استعراض قائمة مدراء الإدارات",
            icon: "fa-solid fa-user-tie",
            hasDate: true
          },
          {
            id: "section_admin",
            name: "استعراض قائمة رؤساء الأقسام",
            icon: "fa-solid fa-users-gear",
            hasDate: false
          },
          {
            id: "all",
            name: "استعراض قائمة الموظفين",
            icon: "fa-solid fa-users",
            hasDate: false
          }
        ]

      } else {
        this.reports = [
          {
            id: "department_admin",
            name: "Review the list of department managers",
            icon: "fa-solid fa-user-tie",
            hasDate: true
          },
          {
            id: "section_admin",
            name: "Review the list of section heads",
            icon: "fa-solid fa-users-gear",
            hasDate: false
          },
          {
            id: "all",
            name: "Review the list of employees",
            icon: "fa-solid fa-users",
            hasDate: false
          }
        ]
      }
    })

  }
  reports = [] as any[]

  downloadreport(type: string) {


    this.adminService.DownloadUsersReport(type).subscribe((x) => {
      const blob = new Blob([x], { type: x.type });
      const url = window.URL.createObjectURL(blob);
      const anchor = document.createElement('a');
      anchor.href = url;
      anchor.download = "";
      anchor.click();
      window.URL.revokeObjectURL(url);
    });
  }


  viewReport(type: string) {
    this.selectedType = type;
    this.adminService.viewUsersReport(type).subscribe((response: any) => {
      const { reportHeader, users } = response['data'];
      this.users = users;
      this.reportHeader = reportHeader;
    })
  }
}
